module.exports = "/_next/static/images/Commercial-Header-0cb49cfd67dd755c8410dcc7ae2e22ae.jpg";